<div class="card card-l card-border-1 full-width">
  <div class="card-body grid grid-column justify-content-between">
    <div>
      <div class="min-h-72">
        <div class="typography typography-headline typography-bold">
          Стоимость:
        </div>
        <span class="typography typography-headline gray-400" *ngIf="repository.priceWithoutDiscount$ | async as priceWithoutDiscount">
          <s strikeColor="--primary-color">
            {{ priceWithoutDiscount }}&nbsp;{{ currency$ | async }}
          </s>&nbsp;
        </span>
        <span class="typography typography-huge">
          {{ repository.price$ | async }}&nbsp;{{ currency$ | async }}
        </span>
      </div>

      <div class="divider" style="margin: 16px 0"></div>

      <div *ngIf="showBiomaterialServices$ | async">
        <span class="typography mr-8"> Взятие биоматериала: </span>

        <span class="tag tag-violet">
          {{ priceTitle$ | async }}
        </span>
      </div>

      <app-catalog-short-description></app-catalog-short-description>
    </div>

    <div
      class="mt-32 grid grid-gutter-12 grid-nowrap align-items-end"
      [ngSwitch]="(repository.nomenclature$ | async)?.preorderAvailability"
    >
      <div
        class="grid-item"
        [class.grid-xs-6]="repository.isShowHelixExpressAd$ | async"
      >
        <a
          class="button button-primary"
          [routerLink]="['/', HelixRoutes.MobileService]"
          *ngSwitchCase="PreorderAvailability.MobileService"
        >
          Уточнить&nbsp;стоимость
        </a>

        <div
          class="button button-primary full-width"
          appPreventDoubleclick
          (throttledClick)="orderOnlyInDiagnosticCenter()"
          [throttleTime]="1000"
          [attr.data-catalog-item-preorder-hxid]="
            (repository.nomenclature$ | async)?.hxid
          "
          *ngSwitchCase="PreorderAvailability.OnlyInDiagnosticCenter"
        >
          Записаться
        </div>

        <div
          class="button button-primary full-width"
          appPreventDoubleclick
          (throttledClick)="repository.openModalAppointmentDoctor()"
          [throttleTime]="1000"
          [attr.data-catalog-item-preorder-hxid]="
            (repository.nomenclature$ | async)?.hxid
          "
          *ngSwitchCase="PreorderAvailability.Appointment"
          data-testid="appointment-button"
        >
          Записаться
        </div>

        <div
          class="button button-primary full-width"
          appPreventDoubleclick
          (throttledClick)="orderAvailable()"
          [throttleTime]="1000"
          [attr.data-catalog-item-preorder-hxid]="
            (repository.nomenclature$ | async)?.hxid
          "
          *ngSwitchCase="PreorderAvailability.Available"
        >
          <span class="hidden-xs">Заказать&nbsp;анализ</span>
          <span class="hidden block-xs">Заказать</span>
        </div>
      </div>

      <div
        *ngIf="repository.isShowHelixExpressAd$ | async"
        class="grid-item grid-xs-6 hidden block-sm"
      >
        <div
          class="button button-secondary full-width button-discount"
          (click)="scrollTo.emit()"
        >
          Скидки до&nbsp;{{ Discount.Amount }}{{ Discount.UnitMeasurement }}
        </div>
      </div>
    </div>
  </div>
</div>
